import Store from "../../../../../../Store";

import hr from "./images/hr.png";

export const mockImages = { hr };

export const getMockImage = () => {
  const short = Store.getUserPlatformLangShort();
  return mockImages[short];
};
